import restApi from './restApi';
import qrcode from "qrcode-generator";
import * as billing from "./billing";
import {errorTypeAction} from "./errorTypeAction";


export const getSession = () => $('meta[name="FITCLOUDSESSION"]').attr('content');
export const getCorpId = () => $('meta[name="corpId"]').attr('content');
export const getUserAuth = () => $('meta[name="userAuth"]').attr('content');
export const getOriginCorpId = () => $('meta[name="originCorpId"]').attr('content');
export const getloginCorpAuth = () => $('meta[name="loginCorpAuth"]').attr('content');

/**
 * datepicker arrowsInit
 */
export const arrowsInit = () => {
	let arrows;
	if (KTUtil.isRTL()) {
		arrows = {
			leftArrow: '<i class="la la-angle-right"></i>',
			rightArrow: '<i class="la la-angle-left"></i>',
		};
	} else {
		arrows = {
			leftArrow: '<i class="la la-angle-left"></i>',
			rightArrow: '<i class="la la-angle-right"></i>',
		};
	}
	return arrows;
};

export const dateRegExpress = (regItem) => {
	return regItem.replace(/\-/g,'');
};


export const copyToClipboard = (str) => {
	let textArea = $('<textarea>').appendTo('body');
	textArea.val(str);
	
	textArea[0].select();
	document.execCommand("copy");
	textArea.remove();
};


/**
 * dateRangepicker 함수들
 */
export const formatDate = (date, splet, dpsFlag) => {
		let rtnVal = '';
		const d = new Date(date);
		let month = `${d.getMonth() + 1}`;
		let day = `${d.getDate()}`;
		const year = d.getFullYear();
		if (month.length < 2) month = `0${month}`;
		if (day.length < 2) day = `0${day}`;

		if (dpsFlag === 'y') {
			rtnVal = year;
		} else if (dpsFlag === 'm') {
			rtnVal = [year, month].join(splet);
		} else if (dpsFlag === 'd') {
			rtnVal = [year, month, day].join(splet);
		} else {
			rtnVal = '';
		}
		return rtnVal;
	};

export	const addDay = (keyDate, addNum) => {
		const toDate = new Date(`${keyDate.substring(0, 4)}-${keyDate.substring(4, 6)}-${keyDate.substring(6, 8)}`);
		const rtnVal = toDate.setDate(toDate.getDate() + addNum);
		return rtnVal;
	};

export const daterangepickerInit = async (options = {}) => {
	const today = moment();
	const start = today.clone().subtract(6, 'days');
	const end = today;
	const formattedStart = start.format('YYYY-MM-DD');
	const formattedEnd = end.format('YYYY-MM-DD');

	const defaultOptions = {
		locale: { cancelLabel: 'Cancel' },
		buttonClasses: 'btn',
		applyClass: 'btn-primary',
		cancelClass: 'btn-secondary',
		startDate: start,
		endDate: end,
	};

	const mergedOptions = { ...defaultOptions, ...options };

	$('#daterangepicker .form-control').val(`${formattedStart} / ${formattedEnd}`);

	$('#daterangepicker').daterangepicker(mergedOptions, (start, end, label) => {
		const formattedStart = start.format('YYYY-MM-DD');
		const formattedEnd = end.format('YYYY-MM-DD');
		$('#daterangepicker .form-control').val(`${formattedStart} / ${formattedEnd}`);
	});
};

export	const addMonth = (keyDate, addNum) => {
		const toDate = new Date(`${keyDate.substring(0, 4)}-${keyDate.substring(4, 6)}-01`);
		const rtnVal = toDate.setMonth(toDate.getMonth() + addNum);
		return rtnVal;
	};


export const getPreviousBillingPeriod = (inputPeriod, monthsAgo = 1) => {
	const match = inputPeriod.match(/^(\d{4})-?(\d{2})$/);
	if (!match) {
		throw new Error("Invalid format: Expected 'YYYYMM' or 'YYYY-MM'");
	}

	const isHyphenFormat = inputPeriod.includes("-");

	const year = parseInt(match[1], 10);
	const month = parseInt(match[2], 10);
	const monthIdx = month -1;

	const date = new Date(year, monthIdx, 1);
	date.setMonth(date.getMonth() - monthsAgo);

	const newYear = date.getFullYear();
	const newMonth = (date.getMonth() + 1).toString().padStart(2, '0');

	return isHyphenFormat ? `${newYear}-${newMonth}` : `${newYear}${newMonth}`;
};

/**
 * 에러 처리
 * 에러 타입에 따라 다른 액션
 * @param {*} e - 에러 객체
 */
export const errorHandling = (e) => {
	/**
	 * e.message = "{"code":"xxx","message":"xxx"}"
	 */
	try{
		const response = JSON.parse(e.message);
		const errorAction = errorTypeAction[response.code] ? errorTypeAction[response.code].action : '';
		const errorMessage = response.message;
		const msg = errorMessage.replace(/\n/g, '<br/>');

		swal.fire({
			title: 'ERROR',
			html: msg,
			type: 'error',
		}).then(errorAction);
	} catch{
		swal.fire(
			'ERROR!',
			`관리자에게 문의해 주세요.`,
			'error',
		)
	}
	return false;
};


/**
 * DataTable에서 쓸 수 있도록 데이터 가공
 * 원본 데이터에 사용
 * @param {*} collection
 * @param {*} columns
 * @param {*} total
 */
export const groupByTableData = (collection, columns, total = ['usage_fee'], groupType = 'single') => {
	let recordId = 0;
	const existingKeys = [];
	const result = [];


	for (let i = 0; i < collection.length; i += 1) {
		// 숫자 데이터 변환
		// eslint-disable-next-line no-restricted-syntax
		for (const key in collection[i]) {
			// 숫자 체크
			if ((!Number.isNaN(Number(collection[i][key])) && (collection[i][key] !== ''))) {
				// Date 타입인 경우 체크
				if ((key !== 'billing_period') && (key !== 'account_id')) {
					// eslint-disable-next-line no-param-reassign
					collection[i][key] = parseFloat(collection[i][key]);
				}
			}
		}

		// 데이터 변환
		const groupKey = groupType === 'single'
			? collection[i][columns[0][0]]
			: columns[0].map(col => collection[i][col]).join(',');


		const index = existingKeys.indexOf(groupKey);

		if (index > -1) {
			result[index].others.push(collection[i]);
			total.forEach((key) => {
				result[index][key] += parseFloat(collection[i][key]);
				result[index][key] = parseFloat(result[index][key].toFixed(10));
			});
		} else {
			existingKeys.push(groupKey);

			const temp = {};
			recordId += 1;
			temp.record_id = recordId;
			temp.others = [collection[i]];
			total.forEach((item, index2) => {
				temp[total[index2]] = parseFloat(collection[i][item]);
			});
			columns[0].forEach((item, index2) => {
				temp[columns[0][index2]] = collection[i][item];
			});

			result.push(temp);
		}
	}

	// 3뎁스 이상인 경우
	if (columns[1] !== undefined) {
		result.forEach((item1) => {
			// eslint-disable-next-line no-param-reassign
			item1.others = groupByTableData(item1.others, [columns[1]], total);
		});
		columns.shift();
	}

	// 금액순으로 정렬
	const sortingField = total[0];
	result.sort((a, b) => b[sortingField] - a[sortingField]);

	return result;
};



/**
 * Data 중복 제거 함수
 * @param {*} array
 * @param {*} key
 */
export function removeDuplicate(array, key) {
	return array.filter((item, i) => array.findIndex(item2 => item[key] === item2[key]) === i);
}


/**
 * 제공 칼럼 기준으로 데이터 차원 분할
 * @param {*} data
 * @param {*} columnName
 * @param {*} targets
 * @param {*} selectPickerId - selectpicker id 제공 시, option append 자동
 * @param {*} compareChk
 */
export const dataFilter = (data, columnName, targets, selectPickerId = '', compareChk = true) => {
	let filteredData = [];
	const columnList = [];



	// columnList 생성
	$.each(data, (key1) => {
		let duplicateChk = true;
		$.each(columnList, (key2) => {
			// eslint-disable-next-line no-param-reassign
			data[key1][columnName[0]] = data[key1][columnName[0]] === '' ? 'No Region' : data[key1][columnName[0]];
			if (data[key1][columnName[0]] === columnList[key2][0]) {
				duplicateChk = false;
			}
		});

		if (duplicateChk) {
			columnList.push([data[key1][columnName[0]]]);
			if (columnName.length > 1) {
				columnList[columnList.length - 1].push(data[key1][columnName[1]]);
			}
		}
	});
	// 정렬
	// eslint-disable-next-line no-nested-ternary
	columnList.sort((a, b) => (a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0));


	// selectPicker init
	if (selectPickerId !== '') {
		const selectPicker = $(`#${selectPickerId}`);
		selectPicker.text('');
		$.each(columnList, (key) => {
			const subtext = columnList[key].length > 1 ? ` data-subtext="${columnList[key][1]}"` : '';
			selectPicker.append(`<option${subtext}>${columnList[key][0]}</option>`);
		});
		selectPicker.selectpicker('refresh');
	}

	// 데이터 필터링
	if (targets.length) {
		$.each(data, (key1) => {
			let duplicateChk = false;
			$.each(targets, (key2) => {
				if (compareChk) {
					if (data[key1][columnName[0]] === targets[key2]) {
						duplicateChk = true;
					}
				} else if (data[key1][columnName[0]] !== targets[key2]) {
					duplicateChk = true;
				}
			});
			if (duplicateChk) {
				filteredData.push(data[key1]);
			}
		});
	} else {
		filteredData = data;
	}

	return filteredData;
};


/**
 * datatable reload
 */
export const eventsCapture = () => {
	$('.kt_datatable')
		.on('kt-datatable--on-layout-updated', () => {
			setTimeout(() => {
				KTApp.initComponents();
			}, 0);
		});
};


/**
 * 화면상에 프로그래스 바 표시
 * @param {*} progressId
 * @param {*} modalId
 * @param {*} regionCount
 * @param {*} regionLength
 */
export const progressUI = (progressId, modalId, regionCount, regionLength) => {
	let width = 0;
	width = Math.round((regionCount / regionLength) * 100);
	$(`#${progressId}`).attr('style', `width:${width}%`);
	$(`#${progressId}`).text(`${width} %`);
	if (width >= 100) {
		setTimeout(() => {
			$(`#${modalId}`).modal('hide');
		}, 700);
	}
	$(`#${modalId}`).on('hidden.bs.modal', () => {
		$(`#${progressId}`).attr('style', 'width:0.1%');
		$(`#${progressId}`).text('0%');
		$(`#${progressId}content`).text('');
	});
};


/**
 * UI Block
 * @param {*} eid - element ID
 * @param {boolean} status - 블락 상태 true & false
 * @param {*} text - 표시될 텍스트입력 없을 시 기본 문구 출력
 */
export const blockUI = (eid, status, text = '데이터 로딩중입니다...') => {
	if (status) {
		KTApp.block(`#${eid}`, {
			overlayColor: '#000000',
			type: 'loader',
			state: 'success',
			message: text,
		});
	} else {
		KTApp.unblock(`#${eid}`);
	}
};


// form Data -> Object 변환
jQuery.fn.serializeObject = function serializeObject() {
	let obj = null;
	try {
		if (this[0].tagName && this[0].tagName.toUpperCase() === 'FORM') { const arr = this.serializeArray(); if (arr) { obj = {}; jQuery.each(arr, function a() { obj[this.name] = this.value; }); } }
	} catch (e) {
		alert(e.message);
	}
	return obj;
};


/**
 * 숫자 변환 유틸
 */
export const DspUtil = (function DspUtil() {
	/**
	   * 화면에 음수 일때 red 표시
	   * 숫자는 오른쪽 정렬
	   * @param {*} inData 입력 숫자값
	   * @param {*} dsp    $,￦ 표시
	   */
	let minusCurrency = '';

	// 콤마 나누는 부분
	function commaSplit(n) {
		const txtNumber = `${n}`;
		const rxSplit = new RegExp('([0-9])([0-9][0-9][0-9][,.])');
		const arrNumber = txtNumber.split('.');
		arrNumber[0] += '.';

		do {
			arrNumber[0] = arrNumber[0].replace(rxSplit, '$1,$2');
		}
		while (rxSplit.test(arrNumber[0]));

		if (arrNumber.length > 1) {
			return arrNumber.join('');
		}
		return arrNumber[0].split('.')[0];
	}

	const getMinusDsp = function getMinusDsp(inData, diz, type = 'html') {
		let orgParmData = inData;

		if (Number.isNaN(Number(inData)) === true) { // 문자는 '-' return
			if (type === 'num') {
				return '0';
			}
			return '-';
		}

		let spanColor = '';
		let dspMinus = '';
		if (inData < 0) {
			spanColor = '; color:red';
			dspMinus = '-';
			orgParmData *= -1;
		}

		// 0 자  체우기 (위에)
		function numpad(n, width, flag) {
			let zero = n;
			zero += '';
			if (flag === 'f') {
				return zero.length >= width ? zero : new Array(width - zero.length + 1).join('0') + n; // 앞에 ..
			} if (flag === 'b') {
				return zero.length >= width ? zero : zero + new Array(width - zero.length + 1).join('0'); // 뒤에..
			}
			return zero;
		}

		dspMinus += minusCurrency; // 표시 화폐
		// 원천 데이터 표시
		// totalCost = dspMinus + dsp  + Number( Math.abs(inData ) ).toLocaleString('en');
		// totalCost = dspMinus + dsp  + Number( inData ).toLocaleString('en');
		// // 소숫점 처리 (동일하게 처리)
		let dizValue;
		if (diz !== '') {
			dizValue = Number(numpad(1, diz + 1, 'b'));
		}
		const num = Number(orgParmData);
		let modNum;

		if (type === 'number') {
			// return Number(num.toFixed(diz));  // 반올림
			return Math.floor(num * dizValue) / dizValue;
		}

		if (diz !== '') {
			modNum = Math.floor(num * dizValue) / dizValue;
		} else {
			modNum = num;
		}
		if (modNum === 0) {
			dspMinus = minusCurrency;
			spanColor = '';
		}
		const totalCost = dspMinus + commaSplit(modNum);

		if (type === 'html') {
			return `<span class="text-monospace font-weight-bold" style=" text-overflow:ellipsis;overflow: hidden;white-space: nowrap;  ${spanColor} " data-skin="dark" data-toggle="kt-tooltip" data-placement="right" title="${dspMinus}${commaSplit(orgParmData)}" >${totalCost}</span>`;
		} if (type === 'sum') {
			return `<span data-skin="dark" data-toggle="kt-tooltip" data-placement="right" title="${dspMinus + commaSplit(orgParmData)}" >${totalCost}</span>`;
		} if (type === 'text') {
			return totalCost;
		} if (type === 'num') {
			// eslint-disable-next-line no-useless-escape
			return totalCost.replace(/\,/g, '');
		}
		return totalCost;
	};

	const setCurrency = (currency) => {
		minusCurrency = currency;
	};

	return {
		getMinusDsp: (orgParmData, diz, type) => {
			setCurrency('');
			return getMinusDsp(orgParmData, diz, type);
		},
		getMinusDspSe: (orgParmData, diz = '', type, currency) => {
			setCurrency(currency);
			return getMinusDsp(orgParmData, diz, type);
		},
		getMinusDspSeNotBold: (orgParmData, diz='', type, currency) => {
			setCurrency(currency);
			return getMinusDsp(orgParmData, diz, type)
							.replace('font-weight-bold', '');
		},
		commaSplit: zero => commaSplit(zero),

	};
}());


/**
 * URI 쿼리스트링 함수
 */
export const getQuery = () => {
	const url = document.location.href;
	const qs = url.substring(url.indexOf('?') + 1).split('&');
	const result = {};
	for (let i = 0; i < qs.length; i += 1) {
		qs[i] = qs[i].split('=');
		result[qs[i][0]] = decodeURIComponent(qs[i][1]);
	}
	return result;
};


/**
 * async 함수
 * region api사용하여 불러온 후 배열로 리턴
 */
export const getRegions = () => {
	const myHeaders = new Headers();
	myHeaders.append('FITCLOUDSESSION', getSession());
	myHeaders.append('loginToken', sessionStorage.getItem("loginToken"));
	const myInit = {
		method: 'POST',
		headers: myHeaders,
	};
	return window.fetch('/regions', myInit)
		.then(response => response.json())
		.catch(error => errorHandling(error));
};

/**
 * async 함수
 * corpId를 제공하면 해당하는 업체의 AWS Account List를 불러온 후 리턴
 * @param {*} corpId
 */
export const getAccountList = (corpId = getCorpId()) => {
	const myHeaders = new Headers();
	myHeaders.append('FITCLOUDSESSION', getSession());
	myHeaders.append('loginToken', sessionStorage.getItem("loginToken"));
	const formData = new FormData();
	formData.append('corpId', corpId);
	const myInit = {
		method: 'POST',
		headers: myHeaders,
		body: formData,
	};
	return window.fetch("/account/list", myInit)
		.then(response => response.json())
		.catch(error => errorHandling(error));
};

/**
 * async 함수
 * corp 정보 불러와서 리턴
 * @param {*} corpId
 */
export const getCorp = (corpId = getCorpId()) => {
	const myHeaders = new Headers();
	myHeaders.append('FITCLOUDSESSION', getSession());
	myHeaders.append('loginToken', sessionStorage.getItem("loginToken"));
	const formData = new FormData();
	formData.append('corpId', corpId);
	const myInit = {
		method: 'POST',
		headers: myHeaders,
		body: formData,
	};
	return window.fetch(restApi.corp, myInit)
		.then(response => response.json())
		.catch(error => errorHandling(error));
};


/**
 * 세션 체크
 * @param {*} res
 */
export function sessionChk(res) {
	const sessionMsg = JSON.parse(res.responseText);
	sessionMsg.forEach((item) => {
		const sessionResponseMsg = item.message;
		if (sessionResponseMsg === 'Failed to check session.') {
			window.location.href = '/logout';
		}
	});
}


/**
 * region 목록을 제공하면 originData에서 해당 리전에 해당하는 데이터만 추출하여 return
 * @param {*} originData
 * @param {*} regionList
 */
export const regionDataFilter = (originData, regionList) => originData.reduce((acc, cur) => {
	const region = Object.keys(cur)[0];
	const isRegion = regionList.some(item => item === region);
	if (isRegion) return acc.concat(cur[region]);
	return acc;
}, []);


/**
 * region 목록을 제공하면 selectpicker 초기화
 * @param {*} regionList
 */
export const regionPickerInit = (regionList) => {
	$('#regionpicker').text('');
	$('#regionpicker').selectpicker('refresh');
	regionList.forEach((region) => {
		$('#regionpicker').append(`<option>${region}</option>`);
	});
	$('#regionpicker').selectpicker('refresh');
};


/**
   * 숫자데이터만 float형을 변환하여 return
   */
export const dataParseFloat = data => data.map(
	entry => Object.entries(entry).reduce(
		(obj, [key, value]) => {
			const isNumber = !Number.isNaN(Number(value)); // 숫자인지 체크
			const isExceptVal = (key !== 'billing_period') && (key !== 'account_id'); // 숫자여도 형변환되면 안되는 경우 체크
			/* eslint-disable no-param-reassign */
			obj[key] = (isNumber && isExceptVal) ? parseFloat(value) : value;
			return obj;
		}, {},
	),
);


/**
 * API호출 공통화(비동기)
 * @param {string} url
 * @param {*} success - API완료 후 실행할 함수
 * @param {Object} params - formData
 * @param {string} method - HTTP메서드(기본값: POST)
 * @param {boolean} isJson - nodejs서버로 보내는 데이터는 json형태로 보내야 해서 추가함, supportcenter에서 사용
 * @param {boolean} showPopup - API호출 시 팝업을 띄울지 여부
 */
export const customFetch = (url, success, params, method = 'POST', isJson = false, showPopup = true) => {
	const headers = new Headers();
	headers.append('FITCLOUDSESSION', getSession());
	headers.append('loginToken', sessionStorage.getItem("loginToken"));
	if (isJson) headers.append('Content-Type', 'application/json');
	const myInit = {
		method,
		headers,
	};

	if (method.toUpperCase() === "GET"){
		url = url + parseQueryString(params, '?');
	} else {
		// params가 있는 경우 body에 formData로 추가
		if (params !== undefined) {
			if (params instanceof FormData) {
				myInit.body = params;
			} else {
				const formData = new FormData();
				Object.keys(params).forEach((key) => {
					formData.append(key, params[key]);
				});
				if (isJson) {
					myInit.body = JSON.stringify(params);
				} else {
					myInit.body = formData;
				}
			}
		}
	}

	const myRequest = new Request(url, myInit);
	return window.fetch(myRequest)
		.then((response) => {
			if (response.ok) {
				return response.json().catch(() => ({})); // 응답 데이터가 없는 경우 빈 객체 반환
			} else {
				return response.text().then(text => { throw new Error(text) })
			}
		})
		.then((data) => {
			if(data.length === 0){
				if(showPopup) {
					swal.fire(
						'알림',
						'조회할 데이터가 없습니다!',
						'info',
					);
				}
				blockUI('content-wrap',false);
				success(data);
			}else{
				const { state } = data;
				if (state) {
					success(data.result);
				} else if (state === undefined) {
					// TODO: response 통일되면 없어질 로직 현재는 배열로 리턴되는 경우가 있어서 추가함
					if (data[0] !== undefined && data[0].state === false) {
						throw new Error(data[0].message);
					}
					success(data);
				} else {
					throw new Error(data.message);
				}
			}
			
		}).catch(e => errorHandling(e));
};

const parseQueryString = (params, delimiter) => {
	let queryString = '';

	if (typeof params === 'string') {
		queryString = delimiter + params;

	} else if (typeof params === 'object' && Object.keys(params).length !== 0) {
		const paramQueryStrings = [];
		Object.entries(params).forEach((item) => {
			const key = item[0];
			const values = parseQueryStringValues(item[1]);

			const paramQueryString = values.map(e => key+e).join('&');
			paramQueryStrings.push(paramQueryString);
		});

		// Query String의 경우 특수 문자를 전달할 수 없어 인코딩 이후 전달 함.
		queryString = delimiter
				+ new URLSearchParams(paramQueryStrings.join('&')).toString();
	}

	return queryString;
}

const parseQueryStringValues = (item) => {
	if(item === null) {
		return ['='];
	} else if(typeof item === 'string') {
		return ['=' + item];
	} else if(Array.isArray(item)) {
		const arrayParams = [];
		item.forEach((arrayItem, idx) => {
			const paramValues = parseQueryStringValues(arrayItem);
			paramValues.forEach((paramValue) => {
				arrayParams.push("[" + idx + "]" + paramValue);
			});
		});
		return arrayParams;

	} else if(typeof item === 'object') {
		const objectParams = [];
		Object.entries(item).forEach((objectItem) => {
			const key = objectItem[0];
			const value = objectItem[1];

			const paramValues = parseQueryStringValues(value);
			paramValues.forEach((paramValue) => {
				objectParams.push("[" + key + "]" + paramValue);
			});
		});
		return objectParams;

	}
}

/**
 * API호출 공통화
 * window.fetch promise return
 * @param {string} url
 * @param {Object} params - formData
 * @param {string} method - HTTP메서드(기본값: POST)
 * @param isJson
 */
export const returnCustomFetch = (url, params, method = 'POST', isJson = false) => {
	const headers = new Headers();
	headers.append('FITCLOUDSESSION', getSession());
	headers.append('loginToken', sessionStorage.getItem("loginToken"));
	const myInit = {
		method,
		headers,
	};

	// params가 있는 경우 body에 formData로 추가
	if (params !== undefined) {
		// FormData로 들어오는 경우도 처리
		if (params instanceof FormData) {
			myInit.body = params;
		} else {
			if(!isJson){
				const formData = new FormData();
				Object.keys(params).forEach((key) => {
					formData.append(key, params[key]);
				});
				myInit.body = formData;
			}else {
				myInit.body = JSON.stringify(params);
				headers.append("Content-Type", "application/json");
			}
		}
	}

	const myRequest = new Request(url, myInit);
	return window.fetch(myRequest)
		.then((response) => {
			if (response.ok) {
				return response.json();
			} else {
				return response.text().then(text => { throw new Error(text) })
			}
		}).catch(e => errorHandling(e));
};

export const swalError = msg => swal.fire(
	'ERROR!',
	msg,
	'error',
);

/**
 * urlFetch 여러개 해야 할 경우 사용할 공통 함수
 * @param {*} urls url 배열
 * @param {*} success 성공했을 시 데이터 Callback
 * @param {*} params 파라미터
 * @param {*} method post,get,put,delete
 */
export const customMultiFetch = (urls, success, params, method = 'POST') => {
	const headers = new Headers();
	headers.append('FITCLOUDSESSION', getSession());
	headers.append('loginToken', sessionStorage.getItem("loginToken"));
	const myInit = {
		method,
		headers,
	};
	// params가 있는 경우 body에 formData로 추가
	if (params !== undefined) {
		// FormData로 들어오는 경우도 처리
		if (params instanceof FormData) {
			myInit.body = params;
		} else {
			const formData = new FormData();
			Object.keys(params).forEach((key) => {
				formData.append(key, params[key]);
			});
			myInit.body = formData;
		}
	}

	let requests = [];
	const isPromise = Promise.resolve(urls[0]) === urls[0];
	if (isPromise) {
		requests = urls;
	} else {
		urls.forEach((url) => {
			const request = window.fetch(url, myInit);
			requests.push(request);
		});
	}


	return Promise.all(requests)
		.then(responses => responses)
		.then(responses => Promise.all(responses.map(r => r.json())))
		.then((datas) => {
			if (datas[0][0] === null || datas[1]=== []) {
			 	swal.fire(
		          '알림',
		          '조회할 데이터가 없습니다!',
		          'info',
		        );
	        } else {
			success(datas);
			}
		});
};

export const selectPickerInit = () => {
	$('.kt-selectpicker').selectpicker();
};

export const csvCreate = (csvRows, FileName) => {
	const csvString = csvRows.join('\n');
	const csvFile = new Blob([`\ufeff${csvString}`], { type: 'text/csv;charset=utf-8;' });
	const downloadLink = document.createElement('a');
	downloadLink.download = FileName;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = 'none';
	document.body.appendChild(downloadLink);
	downloadLink.click();
};

/**
 * 기준일 초기화
 */
export const lastUpdateInit = async () => {
	const isEdp = window.location.hostname.includes('edp');

	const params = {};
	if (isEdp) {
		params.keyName = 'cur_last_update';
	} else {
		params.name = 'cur_last_update';
	}

	let curStr;
	await customFetch(restApi.status, (data) => {
		curStr = `${data[0].value}`;

		const date = new Date(new Date(curStr).getTime());
		const lastMonthDate = new Date(date);
		lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);

		const month = (date.getMonth() + 1).toString().padStart(2, '0');
		const day = date.getDate().toString().padStart(2, '0');
		const hour = date.getHours().toString().padStart(2, '0');

		$('#cur_last_update').text(`${month}월 ${day}일 ${hour}시`);

		// tag explorer
		if ($('#daterangepicker') !== undefined) {
			$('#tagEndDate').val(curStr);
		}
	}, params);
	return moment(curStr).format("YYYYMMDD");
};


/**
 * Date format 변환
 * @param {*} format
 */
export const dateToStr = (format) => {
	const year = format.getFullYear();
	let month = format.getMonth() + 1;
	if (month < 10) month = `0${month}`;
	let date = format.getDate();
	if (date < 10) date = `0${date}`;
	let hour = format.getHours();
	if (hour < 10) hour = `0${hour}`;
	let min = format.getMinutes();
	if (min < 10) min = `0${min}`;
	let sec = format.getSeconds();
	if (sec < 10) sec = `0${sec}`;

	return `${year}-${month}-${date} ${hour}:${min}:${sec}`;
};

/**
   * 끝나는 날짜를 넣으면 남은 날을 return
   */
export const getRemainDay = (endDate) => {
	const now = new Date();
	const endTime = new Date(endDate);

	const differenceDate = endTime.getTime() - now.getTime();
	const remainingDays = differenceDate / (1000 * 3600 * 24);

	if (remainingDays < 0) {
		return 0;
	}
	return Math.floor(remainingDays);
};


export const formatFileSize = (bytes, si = false, dp = 1) => {
	const thresh = si ? 1000 : 1024;

	if (Math.abs(bytes) < thresh) {
		return bytes + 'B';
	}

	const units = si
		? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
		: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	let u = -1;
	const r = 10**dp;

	do {
		bytes /= thresh;
		++u;
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


	return bytes.toFixed(dp) + units[u];
};

export const generateQRCode = (url) => {
	// QR 코드 Generate
	const typeNumber = 7;
	const errorCorrectionLevel = 'L';

	const qr = qrcode(typeNumber, errorCorrectionLevel);
	qr.addData(url);
	qr.make();

	return qr.createImgTag();
}


export const drawChart = (container, data) => {
	const chartType = data.type;
	const labels = data.labels;
	const datasets = data.datasets;
	const options = data.options;

	if (!container) {
		return;
	}

	// 이미지 다운로드시 배경색 white 설정
	Chart.plugins.register({
		beforeDraw: function(chartInstance) {
			const ctx = chartInstance.chart.ctx;
			ctx.fillStyle = "white";
			ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
		}
	});

	const ctx = container.getContext('2d');
	return new Chart(ctx, {
		type: chartType,
		data: {
			labels: labels,
			datasets: datasets
		},
		options: options
	});
}

export const validPeriodDate = (fromVal, toVal) => {
	if (fromVal == null || toVal == null) return;
	if (fromVal === '' || toVal === '') return;
	[fromVal, toVal] = [fromVal.replace(/-/g, ''), toVal.replace(/-/g, '')];
	if (fromVal > toVal) {
		swalError('조회범위 시작은 조회범위 마지막보다 클 수 없습니다.');
		return blockUI('content-wrap',false);
	}
};

export const monthDiff = (dateFrom, dateTo) => {
	let diff = dateTo - dateFrom;
	let currDay = 24 * 60 * 60 * 1000;// 시 * 분 * 초 * 밀리세컨
	let currMonth = currDay * 30;// 월 만듬

	return parseInt(`${diff / currMonth}`);
}


/**
 * 2024-07과 같은 string 형식의  month 차이를 구할 때 사용하는 메서드입니다
 * @param {String} start 시작 년-월
 * @param {String} end   끝나는 년-월
 */
export const monthDifference = (start, end) => {
	const startYear = parseInt(start.slice(0, 4));
	const startMonth = parseInt(start.slice(5, 7));
	const endYear = parseInt(end.slice(0, 4));
	const endMonth = parseInt(end.slice(5, 7));

	return (endYear - startYear) * 12 + (endMonth - startMonth);
};

/**
 * 2024-07-06과 같은 string 형식의 day 차이를 구할 때 사용하는 메서드입니다.
 * @param {String} start 시작 년-월-일
 * @param {String} end 끝나나는 년-월-일
 */
export const dayDifference = (start, end) => {
	const startDate = new Date(start);
	const endDate = new Date(end);

	const differenceInMillis = endDate - startDate;

	const millisPerDay = 1000 * 60 * 60 * 24;
	return Math.floor(differenceInMillis / millisPerDay);
};

/**
 * property 기준으로 그룹핑하는 메서드입니다.
 * @param {Object} data 그룹핑할 컬렉션
 * @param {String} property 그룹핑 기준
 * @param {Object} returnType 반환 타입
 * @returns {Object} property 기준 그룹화한 객체 반환
 */
export const groupBy = (data, property, returnType = {}) => {
	return data.reduce(function (rv, x) {
		(rv[x[property]] = rv[x[property]] || []).push(x);
		return rv;
	}, returnType);
};

export const startButtonSpinnerAnimation = (obj) => {
	$(obj).addClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light');
	$(obj).addClass('disabled');
};

export const endButtonSpinnerAnimation = (obj) => {
	$(obj).removeClass('kt-spinner kt-spinner--right kt-spinner--sm kt-spinner--light');
	$(obj).removeClass('disabled');
}

export const RESELLER_USER_AUTH = ['R', 'RC'];
export const DISABLE_RESELLER_TEXT = '솔트웨어 직계약 고객사에게 제공되는 기능입니다.';

export const isReseller = () => RESELLER_USER_AUTH.some(auth => auth === getUserAuth());

export const disableBtnToReseller = (btnEl, btnTextEl, text = DISABLE_RESELLER_TEXT) => {
	btnEl.attr('disabled', true);
	btnTextEl.attr('data-toggle', 'kt-tooltip');
	btnTextEl.attr('title', text);
	btnTextEl.attr('data-placement', 'left');
}

export const parseCostText = (text, DSP_DECIMAL_POINT) => {
	return DspUtil.getMinusDspSe(text, DSP_DECIMAL_POINT, 'text', '$');
}


export const showConfirmModal = ({ title, text, confirmText, formInfo, method, successTitle, apiUrl, modalId, onSuccess }) => {
	swal.fire({
		title,
		text,
		type: 'warning',
		showCancelButton: true,
		confirmButtonText: confirmText,
		showLoaderOnConfirm: true,
		preConfirm: () => returnCustomFetch(apiUrl, formInfo, method),
	}).then((result) => {
		if (!result.dismiss) {
			const response = result.value;
			if (response.state) {
				swal.fire(
					successTitle,
					response.message,
					'success'
				).then(() => {
					if (modalId) $(modalId).modal('toggle');
					onSuccess?.();
				});
			} else {
				swalError(response.message);
			}
		}
	});
};